import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLanguageStore = defineStore('language', () => {
  // State - initialize with default language
  const currentLanguage = ref('pl')

  // Actions
  function setLanguage(language) {
    currentLanguage.value = language
  }

  // Available languages
  const availableLanguages = ref([
    { code: 'pl', name: 'Polski' },
    { code: 'en', name: 'English' }
  ])

  return {
    currentLanguage,
    availableLanguages,
    setLanguage
  }
}, {
  persist: {
    key: 'app-language',
    storage: localStorage,
    paths: ['currentLanguage']
  }
})
